// Column order for the redesigned Results grid (I360A-2743, flag on).
// The live column list is the source of truth; a saved order only
// rearranges it. Plain arrays only (indexOf where the position is needed) — the module build targets es5.

export function redesignDefaultOrder(
	lofFields: string[],
	cofFields: string[],
): string[] {
	return [
		'ASSET_ID',
		'MATERIAL',
		'DIAMETER',
		'INSTALLATION_YEAR',
		'CURRENT_LOF',
		'CURRENT_COF',
		'CURRENT_RISK',
		'GRADE',
		'RISK_CHANGE',
		'CCTV_INSPECTED',
		'LAST_INSPECTED',
		'DATA_COVERAGE',
		...lofFields,
		...cofFields,
		'Menu',
	];
}

export function reconcileColumnOrder(
	columnFields: string[],
	defaultOrder: string[],
	saved?: string[] | null,
): string[] {
	const exists = (f: string) => columnFields.includes(f);
	const result: string[] = [];
	// Saved order comes from localStorage; anything that isn't an array
	// (corrupted or hand-edited) is treated as nothing saved.
	(Array.isArray(saved) ? saved : defaultOrder).forEach(f => {
		if (exists(f) && !result.includes(f)) result.push(f);
	});

	// Columns the saved order doesn't know about go after the nearest field
	// that precedes them in the default order (a new component lands after
	// its preceding driver field, or after the last summary column).
	defaultOrder.forEach((field, i) => {
		if (!exists(field) || result.includes(field)) return;
		let anchor = -1;
		for (let j = i - 1; j >= 0 && anchor === -1; j--) {
			anchor = result.indexOf(defaultOrder[j]);
		}
		result.splice(anchor + 1, 0, field);
	});

	columnFields.forEach(f => {
		if (result.includes(f)) return;
		const menu = result.indexOf('Menu');
		if (menu === -1) result.push(f);
		else result.splice(menu, 0, f);
	});

	return result;
}
